<template>
  <div>
    <div class="container-fluid">
      <div data-widget-group="group1">
        <ol class="breadcrumb">
          <li>
            <router-link to="/admin">Dashboard</router-link>
          </li>
          <li class="active">Payment Operations</li>
        </ol>
        <div v-if="ErrorMessage" class="alert-danger alert visibility" role="alert">
            {{ ErrorMessage }}
          </div>
          <div v-if="SuccessMessage" class="alert-info alert visibility" role="alert">
            {{ SuccessMessage }}
          </div>
          <div v-if="linkExport" class="alert-info alert visibility" role="alert">
           <a :href="linkExport">Download File : {{fileName}}</a>
          </div>
       <div class="panel-body1 locationform">
           <div class="row ">
              <div class="col-md-3">
                  <div id="search-box">
                    <div class="form-group">
                      <input
                        type="text"
                        class="search-query form-control"
                        placeholder="Search"
                        v-model="searchText"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <button
                      type="button"
                      v-on:click="getAllLeads(1)"
                      class="btn btn-outline-primary"
                    >
                      Search
                    </button>
                  </div>
                </div>
                <div class="col-md-3" v-if="$can('Download','Payment::Operations') || $can('Create','Payment::Operations')">
                   <div class="form-group">
                  <button v-on:click="exportPayment" class="btn btn-outline-primary">Export Payment Request <i class="material-icons">get_app</i> </button>
                   </div>
                </div>
                 <div class="col-md-3" v-if="$can('Upload','Payment::Operations') || $can('Create','Payment::Operations')">
                    <div class="form-group">
                  <button @click="showFileUploadModal = true" class="btn btn-outline-primary">Import Payment Clearance <i class="material-icons">upload</i> </button>
                    </div>
                </div>
           <div class="col-md-12">
               <table
                  class="table table-striped table-bordered"
                  cellspacing="0"
                  width="100%"
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Transaction Code</th>
                      <th>User Name</th>
                      <th>UserCode</th>
                      <th>Partner Type</th>
                      <th>Points Redeemption Request</th>
                      <th>Total Points</th>
                      <th>City</th>
                      <th>State</th>
                    </tr>
                  </thead>
                  <tbody>
                  <!-- <tr class="odd gradeX"> -->
                  <tr
                    v-for="(item, index) in redemption_data"
                    :key="item.id"
                    class="gradeC"
                  >
                    <td>{{ currentPage * pageSize + index + 1 }}</td>
                    <td>{{ item.TransactionId }}</td>
                   <td>{{ item.first_name+" "+item.last_name }}</td>
                   <td>{{ item.UserCode }}</td>
                   <td>{{ item.PartnerType }}</td>
                   <td>{{ item.RedeempRequestPoints }}</td>
                   <td>{{ item.TotalPoints }}</td>
                   <td>{{ item.selectedCity }}</td>
                   <td>{{ item.State }}</td>
                   
                  </tr>
                </tbody>
                </table>
                <!--end table-->
                  <paginate
                  :page-count="TotalPage"
                  :click-handler="getAllLeads"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                >
                </paginate>
           </div>
           </div>
       </div>
       
      </div>
    </div>
     <!-- File Upload Model -->

      <div v-if="showFileUploadModal">
        <transition name="modal">
          <div class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-dialog">
                <div class="modal-content hederpop">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="close button"
                      @click="showFileUploadModal = false"
                    >
                      <span aria-hidden="false">X</span>
                    </button>
                    <h4 class="modal-title">Import File</h4>
                  </div>
                  <div class="modal-body">
                      <div class="col-xs-12">
                            <div v-if="FileSuccessMessage" class="alert-info alert visibility" role="alert">
                                {{ FileSuccessMessage }}
                            </div>
                            <div v-if="FileErrorMessage" class="alert-danger alert visibility" role="alert">
                                {{ FileErrorMessage }}
                            </div>
                            <div v-if="FileImportLink" class="alert-info alert visibility" role="alert">
                            <a :href="FileImportLink">Download File : {{fileName}}</a>
                            </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
    <label> </label>
    <input
      type="file"
      v-on:change="handleFileUpload()"
      id="inputFile4"
      multiple=""
      ref="file"
      name="photo"
    />
    <div class="input-group">
      <input
        type="text"
        readonly=""
        id="addon3"
        class="form-control"
        placeholder="with file chooser..."
      />
      <span class="input-group-btn input-group-sm">
        <button type="button" class="btn btn-fab btn-fab-mini">
          <i class="material-icons">attach_file</i>
        </button>
      </span>
    </div>
 
  </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <!-- File Upload Model -->
  </div>
</template>
<script>
import moment from 'moment'

import Paginate from 'vuejs-paginate';


import commonServices from '../../services/common-services';
export default {
  name: 'paymentOperations',
  data() {
    return {
      redemption_data: [],
      TotalPage: 1,
      searchText: '',
      pageSize: 10,
      currentPage: 1,
      showAddEnq:false,
      ErrorMessage:'',
      SuccessMessage:'',
      linkExport:'',
      fileName:'',
      showFileUploadModal:false,
      FileSuccessMessage:'',
      FileErrorMessage:'',
      FileImportLink:'',
      file:'',
    };
  },
  components: {
    Paginate,
  },
  methods: {
    handleFileUpload(){
       this.file = this.$refs.file.files[0];
       console.log(this.file);
         this.submitFile();
    },
    submitFile(){
       let loader = this.$loading.show();
       let formData = new FormData();
       formData.append('payment', this.file);
       commonServices.post_upload_file('kspgAPI/PaymentImport/import',formData)
       .then(
          (responce) => {
            this.message = responce.data.message;
            if (responce.data.status) {
              this.FileSuccessMessage =  responce.data.message
              this.FileImportLink = responce.data.FileImportLink
              this.fileName = responce.data.fileName
            }
          },
          (error) => {
            //   this.loading = false;
            this.message =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        )
        .catch((e) => {
          this.errors.push(e);
           if(e.response.data.error == "Invalid API key "){
             loader.hide()
             this.$router.push({ name: 'login'});
          }
        });
        setTimeout(() => {loader.hide()}, 1000)
    },
    exportPayment(){
      alert("Be paitent, We are processing your export Request.");
      let loader = this.$loading.show();
      commonServices
        .get('kspgAPI/Payment/exportPaymentList', {})
        .then((response) => {
            if(response.data.status){
              this.fileName = response.data.fileName;
              this.linkExport = response.data.export_sheet_url;
              this.SuccessMessage = response.data.message;
            }
             setTimeout(() => {loader.hide()}, 1000)
        })
        .catch((e) => {
          if(e.response.data.error == "Invalid API key "){
             this.$router.push({ name: 'login'});
          }
           setTimeout(() => {loader.hide()}, 1000)
            setTimeout(() => (this.ErrorMessage = e.response.data.message), 7000);
        });
       
      setTimeout(() => (this.SuccessMessage = false), 7000);
      setTimeout(() => (this.ErrorMessage = false), 7000);
    },
    getRequestParams(searchText, page, pageSize) {
      let params = {};

      if (searchText) {
        params['searchText'] = searchText;
      }

      if (page) {
        params['page'] = page - 1;
      }

      if (pageSize) {
        params['size'] = pageSize;
      }

      return params;
    },
    getAllLeads(pageNum) {
      let loader = this.$loading.show();
      const params = this.getRequestParams(
        this.searchText,
        pageNum,
        this.pageSize
      );
      commonServices
        .get('kspgAPI/Payment/list', params)
        .then((response) => {
          const {
            redemption_data,
            totalItems,
            currentPage,
            TotalPage,
          } = response.data;
          this.redemption_data = redemption_data;
          this.TotalPage = TotalPage;
          this.currentPage = parseInt(currentPage);
        })
        .catch((e) => {
          if(e.response.data.error == "Invalid API key "){
             this.$router.push({ name: 'login'});
          }
        });
        setTimeout(() => {loader.hide()}, 1000)
    },
    format_date(value){
         if (value) {
           return moment(String(value)).format('DD-MM-YYYY')
          }
      },
  },
  beforeCreate() {
    this.$store.commit('SET_LAYOUT', 'app-layout');
  },
  mounted() {
    this.getAllLeads(1)
  },
  filters: {
        truncate: function (text, length, suffix) {
            if(!text){
              return text;
            }
            if (text.length > length) {
                return text.substring(0, length) + suffix;
            } else {
                return text;
            }
        },
    }
};
</script>
<style scoped>
.visibility {
  visibility: visible !important;
}
.btn-outline-primary{color:#007bff;border-color:#007bff}
.btn-outline-primary:hover{color:#fff;background-color:#007bff;border-color:#007bff}
.btn-outline-primary.focus,
.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}
.btn-outline-primary.disabled,
.btn-outline-primary:disabled{color:#007bff;background-color:transparent}
.btn-outline-primary:not(:disabled):not(.disabled).active,
.btn-outline-primary:not(:disabled):not(.disabled):active,.show>
.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#007bff;border-color:#007bff}
.btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>
.btn-outline-primary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
.close {
  color: #000 !important;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-content{
  height: 200px;
}
</style>
